module.exports = __webpack_public_path__ + "img/集成接口2.4d26b002.png";